import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import theme from '../../theme'
// material ui components

import { IconButton } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Select from '@mui/material/Select';

import MenuIcon from '@mui/icons-material/Menu';
import RouterIcon from '@mui/icons-material/Router';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { styled, useTheme } from '@mui/material/styles';

// Material components
import { MenuItem, FormControl, Divider } from '@mui/material'

//import { makeStyles } from '@mui/styles'


import Drawer from '@mui/material/Drawer';


export const drawerWidth = 256


/**
 * menu component
 * @param classes
 * @param handleDrawerState
 * @param onSelectChange
 * @param selectedValue
 * @param open
 * @param children
 * @returns {*}
 * @constructor
 */
const Menu = ({ classes, handleDrawerState, onSelectChange, activeDeviceId, open, children, devices }) => {

    const styles = {
        drawerPaper: {
            transition: "width 3s ease",
            padding:0,
            width: "100vw",
            zIndex:1,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.enteringScreen,
            }), 
            overflowX: 'hidden',
            [theme.breakpoints.down('xs')]: {
                width: '100vw',
            },
            [theme.breakpoints.down('sm')]: {
                width: '100vw',
            }
        },
        drawerPaperClose: {
             overflowX: 'hidden',
            overflowy: 'hidden',
            border: 0,  
            zIndex:1,
            alignItems:"center",
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.leavingScreen,
            }),
            [theme.breakpoints.down('xs')]: {
                //position: 'fixed',
                width: '100vw',
            }, 
    
            [theme.breakpoints.up('sm')]: {
                width: '100vw',
            }, 
            transition: "width 3s ease",
            padding:0,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
              }),
              overflowX: 'hidden',
              width: `calc(${theme.spacing(7)} + 1px)`,
              [theme.breakpoints.up('sm')]: {
                width: `calc(${theme.spacing(8)} + 1px)`,
              },
        },
        toolbar: {
            //Only changes Menu button
            display: 'flex',
            alignItems: 'left',
            justifyContent: 'center',
            backgroundColor: theme.palette.custom.menuHeader,  
            paddingTop:12,
            paddingBottom:12,
            width: "100%"
        },
        content: {
            flexGrow: 1,
            backgroundColor: theme.palette.background.default,
            padding: theme.spacing.unit * 3,
        },
        icon: {
            fill: '#fff',
            display:'flex',
            alignItems:'center'
        },
        drawerHeader: {
            display: 'flex',
            paddingLeft:5,
            alignItems:"left",
            justifyContent: 'left',
            color: '#fff',
            width:"100vw",
            maxWidth:drawerWidth,
            [theme.breakpoints.down('xs')]: {
    
                justifyContent: 'center',
        
            },
            [theme.breakpoints.down('sm')]: {
                
                justifyContent: 'center',
       
            },
        },
        menuHeader: {
            backgroundColor: theme.palette.custom.menuHeader,
        },
        select: {
            'color': '#fff',
            'fill': '#fff',
            'minWidth': 120,
            'borderBottom': '#fff',
            'marginLeft':10,
            'marginRight':10, 
            'paddingLeft':10,
            '&:before': {
                borderColor: '#fff',
            },
            '&:after': {
                borderColor: theme.palette.primary.dark,
            },
            [theme.breakpoints.down('xs')]: {
               // minWidth: 110,
            },
        },
        menuItem: {
            'height': 32,
            'width': 127,
            'fontSize': theme.typography.caption.fontSize,
            'padding': '0 0 0 10px',
            '&:focus': {
                backgroundColor: theme.palette.custom.selectedMenuItem,
            },
        },
    
        listContainer: {
            //For container around drawer menu items
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            width: "100%",
            alignItems:'center',
            backgroundColor:theme.palette.primary.dark,
            [theme.breakpoints.down('xs')]: {
                width: open?'100vw':"100%",
                //backgroundColor:"red",
            },
            [theme.breakpoints.down('sm')]: {
                width: open?'100vw':"100%",
                alignItems:'center',
                //backgroundColor:"red",
            }
        },
    }
    


     return (<Drawer
        variant="permanent"
        //style={!open?styles.drawerPaperClose:styles.drawerPaper}
        //style={styles.drawerPaperClose}
        /* classes={{
            paper: classNames(classes.drawerPaper, !open && classes.drawerPaperClose),
        }} */
        open={open}
        /* sx={{ paper: classNames(styles.drawerPaper, !open && styles.drawerPaperClose) }} */
        sx={!open?styles.drawerPaperClose:styles.drawerPaper}
        
    >
 
        <Box style={styles.toolbar}>
            {open
            && (
                <Box style={styles.drawerHeader} sx={{width:!open?10:"100%"}}>
                    <IconButton id={"menu-close-button"} sx={{marginLeft:1}}>
                        <RouterIcon sx={{color:'#fff'}}/>
                    </IconButton>

                    <FormControl>
                        <Select
                            value={activeDeviceId}
                            style={styles.select} 
                            sx={styles.select}
                            onChange={e => onSelectChange(e.target.value)}
                            variant={'standard'}>
                            {Object.values(devices).map((device, idx) =>
                                <MenuItem key={"manuItem"+idx} style={styles.menuItem} value={device.id}>{device.label}</MenuItem>
                            )}
                        </Select>
                    </FormControl>
                </Box>
            )

            }
            <IconButton id={"menu-close-button"}  onClick={() => handleDrawerState()} sx={{marginRight:open?2:0}}>
                {open ? <ChevronLeftIcon style={styles.icon} /> :
                    <MenuIcon sx={{color:"#fff"}}/>}
            </IconButton>
        </Box>
         <Divider/> 
         <Box style={styles.listContainer}>
            {children}
        </Box> 
    </Drawer>)    
}

Menu.defaultProps = {
    open: false,
    devices: {},
}

Menu.propTypes = {
    open: PropTypes.bool,
    handleDrawerState: PropTypes.func.isRequired,
    onSelectChange: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
    // classes: PropTypes.objectOf(PropTypes.string).isRequired,
    classes: PropTypes.object.isRequired,
    activeDeviceId: PropTypes.string,
}

//export default withStyles(styles)(Menu)
export default Menu
